<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <!-- <v-form ref="form" v-model="valid" :lazy-validation="lazy"> -->
            <v-card class="py-0">
                <v-toolbar class="py-0 my-0" dark color="blue">
                    <v-toolbar-title class="my-0 py-0">Informe de No Conformidad / Acciones Correctivas (EI
                        044) </v-toolbar-title>
                    <v-spacer></v-spacer>
                    Código: {{ codgral }}
                    <v-spacer></v-spacer>
                    <div>
                        <v-btn icon @click="show = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-toolbar>
            </v-card>
            <v-card color="blue lighten-4" class="py-0 my-0">
                <v-card-text class="py-0 my-0">
                    <v-row dense>
                        <v-col cols="12" sm="12" md="10" align-self="stretch">
                            <v-radio-group v-model="tipo" row dense>
                                <v-radio label="De Productos" value="P"></v-radio>
                                <v-radio label="De Gestión" value="G"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card color="blue lighten-5" dense>
                <v-card-text>
                    <v-row dense>
                        <v-col cols="6" sm="4" md="4">
                            <v-radio-group v-model="gravedad" row dense>
                                <v-radio dense label="Mayor" value="M"></v-radio>
                                <v-radio dense label="Crítica" value="C"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            N° de OT: {{ comboot }}
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            Cliente: {{ cliente }}
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="6" sm="6" md="4">
                            Referencia: {{ referencia }}
                        </v-col>
                        <v-col cols="6" sm="6" md="4">
                            Procedimiento / Instrucción: {{ proced }}
                        </v-col>
                        <v-col cols="6" sm="4" md="2">
                            N.P.: {{ numnp }}
                        </v-col>
                        <v-col cols="6" sm="4" md="2">
                            Inf. Inspección: {{ numii }}
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card color="blue lighten-4" dense class="py-0 my-0">
                <v-card-text class="py-0 my-0">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="4">
                            <v-checkbox dense v-model="afectacal" value="ON" label="Afecta Calidad"></v-checkbox>
                        </v-col>
                        <v-col cols="6" sm="6" md="4">
                            <v-checkbox dense v-model="afectama" value="ON" label="Afecta Medio Ambiente"></v-checkbox>
                        </v-col>
                        <v-col cols="6" sm="6" md="4">
                            <v-checkbox dense v-model="afectasst" value="ON" label="Afecta SST"></v-checkbox>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card color="blue lighten-5" class="py-0 my-0">
                <v-card-text class="py-0 my-0">
                    <v-row dense>
                        <h6>Lugar de Detección: </h6>
                    </v-row>
                    <v-row dense>
                        <v-col cols="10" sm="6" md="6">
                            <v-radio-group v-model="lugar" row dense>
                                <v-radio label="Planta" value="P"></v-radio>
                                <v-radio label="Obra" value="O"></v-radio>
                                <v-radio label="Cliente" value="C"></v-radio>
                                <v-radio label="Otro:" value="X"></v-radio>
                                {{ otrolugar }}
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card color="blue lighten-4" class="py-0 my-0">
                <v-card-text class="py-0 my-0">
                    <v-row dense>
                        <h6>Detectado por: </h6>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                            <v-radio-group v-model="detectado" row dense>
                                <v-radio dense label="Auditoría de 1° Parte (Interno)" value="V1"></v-radio>
                                <v-radio dense label="Auditoría de 2° Parte (Cliente)" value="V2"></v-radio>
                                <v-radio dense label="Auditoría de 3° Parte (Entes de Certificación)" value="V3"></v-radio>
                                <!-- <v-row> -->
                                <v-radio dense label="Cliente" value="V4"></v-radio>
                                <v-radio dense label="Área de la Empresa" value="V5"></v-radio>
                                Área: {{ area }}
                                <v-radio dense label="Otros" value="V6"></v-radio>
                                {{ otros }}
                                <!-- </v-row> -->
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card color="blue lighten-5">
                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" sm="4" md="5">
                            Inspector/Originante: {{ originante }}
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            Fecha: {{ fecha }}
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card class="py-0 my-0">
                <v-card-text class="py-0 my-0">
                    <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                            Descripción de la No Conformidad:
                            <div class="multi-line">
                                {{ descr }}
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card class="py-0 my-0">
                <v-card-text class="py-0 my-0">
                    <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                            Acciones Inmediatas:
                            <div class="multi-line">
                                {{ accion }}
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card class="py-0 my-0">
                <v-card-text class="py-0 my-0">
                    <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                            Causa/s de la No Conformidad:
                            <div class="multi-line">
                                {{ causa }}
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card color="blue lighten-4">
                <v-card-text class="py-0 my-0">
                    <v-row align="center" dense>
                        <p align="center">
                        <h5>Clasificación de la No Conformidad</h5>
                        </p>
                    </v-row>
                    <v-row dense>
                        <h6>Causas externas:</h6>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="ccliente"
                                label="Cliente"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="cprov" label="Proveedor"></v-checkbox>
                            {{ proveedor }}
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="ctransp"
                                label="Transporte"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="cotro" label="Otros"></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <h6>Causas internas:</h6>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="respdir"
                                label="Dirección"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="respsgi"
                                label="Adm. del SGI"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="respma"
                                label="Medioambiente"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="respsst" label="SST"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="respobra"
                                label="Obras y Servicios"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox true-value="ON" false-value="" dense v-model="respfabr"
                                label="Fabricación"></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="respcom"
                                label="Comercial"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="respabas"
                                label="Abastecimiento"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="respadm"
                                label="Adm. y Finanzas"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="respssgg" label="SSGG"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="respinsp"
                                label="Inspección y Ensayo"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="respdep"
                                label="Depósito"></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="resprrhh"
                                label="Personal y RRHH"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="respmed"
                                label="Medicina Laboral"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="resptec"
                                label="Gerencia Técnica"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-checkbox dense true-value="ON" false-value="" v-model="respvar" label="Varios"></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="12" md="12" align-self="center">
                            Notificar al Cliente: {{ notificar }}
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card class="py-0">
                    <v-card-text>
                        <v-data-table dense :headers="headers" :items="acciones" locale="es-ar" class="elevation-1"
                            :items-per-page="100" hide-default-footer :footer-props="{
                                itemsPerPageText: 'Items por página',
                            }">
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title> Acciones</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
                <v-card class="py-0">
                    <v-card-text>
                        <v-data-table dense :headers="headersS" :items="seguimientos" locale="es-ar" class="elevation-1"
                            :items-per-page="200" hide-default-footer :footer-props="{
                                itemsPerPageText: 'Items por página',
                            }">
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Seguimiento</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>

            </v-card>

            <v-card>
                <v-card-text>
                    <v-data-table dense :headers="headersE" :items="eficacia" locale="es-ar" class="elevation-1"
                        :items-per-page="10" hide-default-footer :footer-props="{
                            itemsPerPageText: 'Items por página',
                        }">
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title> Control de Eficacia</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </template>
                    </v-data-table>

                    <v-row dense>
                        <v-col cols="6" sm="3" md="3">
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            Estado: {{ estado }}
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card v-if="fileInfos.length > 0">
                <v-list>
                    <v-subheader>Lista de archivos</v-subheader>
                    <v-list-item-group color="primary">
                        <v-list-item v-for="(file, index) in fileInfos" :key="index">
                            <v-list-item-content>
                                <v-list-item-title class="mb-3">
                                    <a target="_blank" :href="'https://api.icssa.com.ar/informes/' + file.descripcion
                                        ">{{ file.titulo }}</a>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card>
            <!-- </v-form> -->
        </v-app>
    </div>
</template>
<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}

.v-input--selection-controls {
    label {
        margin: 0 !important;
    }
}
</style>

<style scoped>
.class label {
    margin-bottom: 0 !important;
}

.multi-line {
    white-space: pre-line;
}
</style>
<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
import readXlsFile from "read-excel-file";
export default {
    data: (vm) => ({
        codgral: "",
        id: "",
        numot: [],
        comboot: "",
        numeroot: "",
        gravedad: "",
        referencia: "",
        tipo: "",
        cliente: "",
        proced: "",
        numnp: "",
        numii: "",
        otrolugar: "",
        otros: "",
        afectacal: "",
        afectama: "",
        afectasst: "",
        lugar: "",
        detectado: "",
        otro: "",
        descr: "",
        accion: "",
        causa: "",
        originante: "",
        proveedor: "",
        prove: [],
        ccliente: "",
        cprov: "",
        ctransp: "",
        cotro: "",
        respdir: "",
        respadm: "",
        respma: "",
        respsst: "",
        respobra: "",
        respfabr: "",
        respcom: "",
        respabas: "",
        respsgi: "",
        respssgg: "",
        respinsp: "",
        respdep: "",
        resprrhh: "",
        respmed: "",
        resptec: "",
        respvar: "",
        notificar: "",
        eficacia: [],
        numreveficacia: "",
        //fechacumpleficacia: "",
        descreficacia: "",
        actaeficacia: "",
        checkeficacia: "",
        fechaeficacia: "",
        fecharevision: "",
        estado: "",
        estadoanalisis: "",
        estadodetalle: "",
        estadoeficacia: "",
        estados: [
            { nombre: 'Pendiente de Analizar', valor: 'P' },
            { nombre: 'Analizado', valor: 'C' },
            { nombre: 'Cerrado', valor: 'T' },
        ],
        fotos: [],
        valid: false,
        deshabilitar: false,
        lazy: false,
        usuario: "",
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        area: "",
        nomarea: [
            { nombre: "Abastecimiento", valor: "Abastecimiento" },
            { nombre: "Administración y Finanzas", valor: "Administración y Finanzas" },
            { nombre: "Comercial", valor: "Comercial" },
            { nombre: "Comité del SGI", valor: "Comité del SGI" },
            { nombre: "Control de Gestión", valor: "Control de Gestión" },
            { nombre: "Depósito", valor: "Depósito" },
            { nombre: "Fabricación", valor: "Fabricación" },
            { nombre: "Gerencia del SGI", valor: "Gerencia del SGI" },
            { nombre: "Ingeniería de Obra", valor: "Ingeniería de Obra" },
            { nombre: "Ingeniería de Producto", valor: "Ingeniería de Producto" },
            { nombre: "Inspección y Ensayos", valor: "Inspección y Ensayos" },
            { nombre: "Medicina Laboral", valor: "Medicina Laboral" },
            { nombre: "Obras y Servicios", valor: "Obras y Servicios" },
            { nombre: "Personal y RRHH", valor: "Personal y RRHH" },
            { nombre: "SSGG y Mantenimiento", valor: "SSGG y Mantenimiento" },
            { nombre: "Técnica y Desarrollo", valor: "Técnica y Desarrollo" },
        ],
        direcciones: [],
        direccion: "",
        correos: "",
        destinatarios: [],
        mail: [{ address: "" }],
        fecha: "",
        date: moment().format("YYYY-MM-DD"),
        menu: false,
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        message: "",
        headers: [
            { text: "Item", value: "item", sortable: false },
            { text: "Descripción", value: "descr", sortable: false },
            { text: "Responsable", value: "resp", sortable: false },
            { text: "Participantes", value: "participante", sortable: false },
            { text: "Plazo", value: "fecha", sortable: false },
            { text: "Cumplido", value: "cumplido", sortable: false },
        ],
        headersS: [
            { text: "Item", value: "item", sortable: false },
            { text: "Descripción", value: "descr", sortable: false },
            { text: "Fecha", value: "fecha", sortable: false },
            { text: "Acta", value: "acta", sortable: false },
            { text: "Cumplido", value: "cumplido", sortable: false },
            { text: "Responsable", value: "resp", sortable: false },
        ],
        headersE: [
            { text: "Revision", value: "numrev", sortable: false },
            { text: "Descripción", value: "descr", sortable: false },
            { text: "Fecha", value: "fechacump", sortable: false },
            { text: "Acta", value: "acta", sortable: false },
        ],
        cumplido: [
            { texto: 'NO', abbr: 'NO' },
            { texto: 'SI', abbr: 'SI' }
        ],
        notif: [
            { texto: 'NO', abbr: 'NO' },
            { texto: 'SI', abbr: 'SI' }
        ],

        acciones: [],
        acc: [],
        seguimientos: [],
        seguim: [],
        acta: "",
        fileInfos: [],
    }),

    //  props: ["visible", "codgral"],
    computed: {
        show: {
            get() {
                // if (this.codgral != null && this.codgral != "") {
                //     this.cargar();
                // console.log("ANTES DEL IF")
                //  }
                //console.log("despues DEL IF")
                // return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    //    this.$refs.form.resetValidation();
                    //   document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        // row_classes(item) {
        //     if (item.estado == "NO" && moment(item.fecha, "DD/MM/YYYY") < moment()) {
        //         return "red";
        //     }
        //     if (item.estado == "NO" && moment(item.fecha, "DD/MM/YYYY") > moment()) {
        //         return "green";
        //     }
        // },

        cargar() {
            const codgral = this.codgral;
            let self = this;
            axios
                .get("/App/CargarEI044?", {
                    params: {
                        codgral: codgral,
                    },
                })
                .then((response) => {

                    self.id = response.data.id;
                    self.tipo = response.data.tipo;
                    self.gravedad = response.data.gravedad;
                    self.comboot = response.data.numot;
                    self.cliente = response.data.cliente;
                    self.referencia = response.data.referencia;
                    self.proced = response.data.proced;
                    self.numnp = response.data.numnp;
                    self.numii = response.data.numii;
                    self.afectacal = response.data.afectacal;
                    self.afectama = response.data.afectama;
                    self.afectasst = response.data.afectasst;
                    self.lugar = response.data.lugar;
                    self.lugarotro = response.data.lugarotro;
                    self.detectado = response.data.detectado;
                    self.area = response.data.area;
                    self.otros = response.data.otros;
                    self.originante = response.data.originante;
                    self.fecha = response.data.fecha;
                    self.descr = response.data.descr;
                    self.accion = response.data.accion;
                    self.causa = response.data.causa;
                    self.ccliente = response.data.ccliente;
                    self.cprov = response.data.cprov;
                    self.proveedor = response.data.proveedor;
                    self.ctransp = response.data.ctransp;
                    self.cotro = response.data.cotro;
                    self.respdir = response.data.respdir;
                    self.respsgi = response.data.respsgi;
                    self.respma = response.data.respma;
                    self.respsst = response.data.respsst;
                    self.respobra = response.data.respobra;
                    self.respfabr = response.data.respfabr;
                    self.respcom = response.data.respcom;
                    self.respabas = response.data.respabas;
                    self.respadm = response.data.respadm;
                    self.respssgg = response.data.respssgg;
                    self.respinsp = response.data.respinsp;
                    self.respdep = response.data.respdep;
                    self.resprrhh = response.data.resprrhh;
                    self.respmed = response.data.respmed;
                    self.resptec = response.data.resptec;
                    self.respvar = response.data.respvar;
                    self.notificar = response.data.notificar;
                    self.numreveficacia = response.data.numreveficacia;
                    self.descreficacia = response.data.descreficacia;
                    self.actaeficacia = response.data.actaeficacia;
                    //self.checkeficacia = response.data.checkeficacia;
                    self.fecharevision = response.data.fechaeficacia;
                    self.estadoanalisis = response.data.estadoanalisis;
                    self.estadodetalle = response.data.estado;
                    self.estadoeficacia = response.data.estadoeficacia;
                    self.fileInfos = response.data.informes;
                    self.acciones = response.data.acciones;
                    self.seguimientos = response.data.seguimiento;
                    self.eficacia = response.data.eficacia;

                    if (self.estadoeficacia == "P") {
                        self.estado = "Pendiente de Eficacia"
                    } else if (self.estadoanalisis == "P") {
                        self.estado = "Pendiente de Seguimiento"
                    } else if (self.estadodetalle == "P") {
                        self.estado = "Pendiente de Analisis"
                    } else {
                        self.estado = "Cerrado"
                    }
                })
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },


        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            const [month, day, year] = date.split("/");
            return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}-`;
        },

        vaciarModels() {
            this.id = "";
            this.area = "";
            this.mail = [];
            this.tipo = "";
            this.descripcion = "";
            this.referencia = "";
            this.fileInfos = [];
            this.numot = [];
            this.comboot = "";
            this.numeroot = "";
            this.gravedad = "";
            this.referencia = "";
            this.tipo = "";
            this.cliente = "";
            this.proced = "";
            this.numnp = "";
            this.numii = "";
            this.otrolugar = "";
            this.otros = "";
            this.afectacal = "";
            this.afectama = "";
            this.afectasst = "";
            this.lugar = "";
            this.detectado = "";
            this.otro = "";
            this.descripcion = "";
            this.accion = "";
            this.causa = "";
            this.estado = "";
            this.fotos = [];
            this.valid = false;
            this.validsubir = false;
            this.deshabilitar = false;
            this.lazy = false;
            this.usuario = "";
            this.area = "";
            this.seguim = [];
            this.acc = [];
            this.ccliente = "";
            this.cprov = "";
            this.proveedor = "";
            this.ctransp = "";
            this.cotro = "";
            this.respdir = "";
            this.respsgi = "";
            this.respma = "";
            this.respsst = "";
            this.respobra = "";
            this.respfabr = "";
            this.respcom = "";
            this.respabas = "";
            this.respadm = "";
            this.respssgg = "";
            this.respinsp = "";
            this.respdep = "";
            this.resprrhh = "";
            this.respmed = "";
            this.resptec = "";
            this.respvar = "";
            this.notificar = "";
            this.numreveficacia = "";
            this.descreficacia = "";
            this.actaeficacia = "";
            this.checkeficacia = "";
            this.fecharevision = "";
            this.estado = "";
            this.eficacia = [];
            this.acciones = [];
            this.seguimientos = [];

        },



    },

    beforeMount() {
        //this.area = this.$route.query.area;
        this.codgral = this.$route.query.codgral;
        this.cargar();

        return this.visible;
    },
};
</script>
  